import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings → Easeedesk → Fast dispatch settings si Sample comments.
 *
 * Perechile vechi: `fast_dispatch`, `get_fast_dispatch_settings`,
 * `save_fast_dispatch_settings`, `sampleComments`, `sampleCommentsData`,
 * `getSampleComment`, `storeSampleComment`, `editSampleComment`,
 * `destroySampleComment`.
 *
 * `apiGet` / `apiPost` pun ELE `/api/v2` in fata caii.
 */

export interface FastDispatchSettings {
  max_distance: number
  check_in: number
  commuting: number
  escalate_button: number
  admin_department: number
  admin_phone: number
}

export interface SampleCommentRow {
  id: number
  comment: string
  created_at: string
  created_by: string
}

const FAST = '/settings/easeedesk/fast_dispatch'
const SAMPLES = '/settings/easeedesk/sample_comments'

export function fastDispatchQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'fast_dispatch'],
    queryFn: () => apiGet<{ title: string; moduleUrl: string; settings: FastDispatchSettings }>(FAST),
  })
}

export function saveFastDispatch(settings: FastDispatchSettings) {
  return apiPost<{ ok?: boolean }>(FAST, {
    max_distance: settings.max_distance,
    check_in: settings.check_in,
    commuting: settings.commuting,
    escalate_button: settings.escalate_button,
    admin_department: settings.admin_department,
    admin_phone: settings.admin_phone,
  })
}

export function sampleCommentsShellQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'sample_comments'],
    queryFn: () =>
      apiGet<{ title: string; moduleUrl: string; canCreate: boolean; canEdit: boolean; canDelete: boolean }>(SAMPLES),
  })
}

export function sampleCommentsTableQuery(search: string, start: number, length: number) {
  const query = `draw=1&start=${start}&length=${length}&search[value]=${encodeURIComponent(search)}`
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'sample_comments', 'table', search, start, length],
    queryFn: () =>
      apiGet<{ draw: number; recordsTotal: number; recordsFiltered: number; data: SampleCommentRow[] }>(
        `${SAMPLES}/table?${query}`,
      ),
  })
}

export function createSampleComment(comment: string) {
  return apiPost<{ ok?: boolean; id?: number }>(SAMPLES, { sample_comment: comment })
}

export function updateSampleComment(id: number, comment: string) {
  return apiPost<{ ok?: boolean }>(`${SAMPLES}/${id}`, { sample_comment: comment })
}

export function removeSampleComment(id: number) {
  return apiPost<{ ok?: boolean }>(`${SAMPLES}/${id}/remove`, {})
}
